/*
 * Copyright (c) Worldline 2023.
 */

import {Injectable} from '@angular/core';
import {RedirectionService} from "./redirection.service";
import {ExternalSignerType} from "../constant/external-signer-type";
import {ActivatedRoute} from "@angular/router";


@Injectable({
    providedIn: 'root'
})
export class SignerService {

    constructor(private redirectionService: RedirectionService) {
    }

    // all the signers
    public signers: any;

    // The current signer
    public currentSigner: any;

    getCurrentSigner() {
        console.debug('getting current signer');
        return this.currentSigner;
    };

    // Loop to check the signer status
    checkStatusLoop(route: ActivatedRoute, sessionId) {
        let that = this;
        //Trigger a loop
        setTimeout(function () {
            that.redirectionService.session(route, sessionId);
        }, 2000);
    };

    // Signer needs to validate the certificate data
    isCertificateApprovalRequired(currentDocumentPosition, numberOfDocuments, typeOfSigner) {
        console.debug('Check if certificate validation is required for document [' + currentDocumentPosition + '/' + numberOfDocuments + '] while signer type is [' + typeOfSigner + ']');
        return currentDocumentPosition >= numberOfDocuments && typeOfSigner === ExternalSignerType.CUSTOMER;
    };

    signerName() {
        if (this.currentSigner) {
            return this.currentSigner.firstName + ' ' + this.currentSigner.lastName
        }
        return undefined
    }
}
